var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',_vm._g(_vm._b({staticClass:"base_avatar",attrs:{"size":_vm.size}},'v-avatar',_vm.$attrs,false),_vm.$listeners),[_c('v-img',{attrs:{"src":_vm.src ? _vm.src : _vm.$findStatic('defaultAvatar'),"cover":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }